<div class="dsDialog_header about-header"></div>
<section class="dsDialog_content about-content">
    <div class="about_banner">
        <h2 class="subTitle">Starter kit</h2>
        <div class="about_version">Version 7</div>
    </div>
    <div class="about_details">
        <h3 class="secTitle">Light & Wonder</h3>
        <p>6601 Bermuda Road<br>Las Vegas, NV 89119</p>
        <h4>www.lnw.com</h4>
        <span>TM and © 2024 Light & Wonder, Inc. and its Subsidiaries. All rights reserved.</span>
    </div>
</section>
<footer class="dsDialog_actions">
    <button class="dsButton" (click)="onClose()">{{ 'HOME.CLOSE' | transloco }}</button>
</footer>
